import type { RouteTypeBucket } from "../../shared/monitoringRouteAuth";
import type { RouteType } from "../../shared/stepConfig";
import type { IconName } from "../components/Icon";

export const ROUTE_TYPE_LABELS: Record<RouteType, string> = {
  webpage: "Webpage",
  api: "API",
  webhook: "Webhook",
  other: "Other",
};

export const ROUTE_TYPE_INLINE_LABELS: Record<RouteType, string> = {
  webpage: "webpage",
  api: "API",
  webhook: "webhook",
  other: "other",
};

export const ROUTE_TYPE_DESCRIPTIONS: Record<RouteType, string> = {
  webpage:
    "Webpage links are HTML pages or forms people open directly in a browser.",
  api: "API links are endpoints called programmatically, usually returning JSON.",
  webhook:
    "Webhook links receive events from external services like Slack, Stripe, or GitHub.",
  other:
    "Other links are everything else, like downloads, redirects, or OAuth callbacks.",
};

const ROUTE_TYPE_BUCKET_LABELS: Record<RouteTypeBucket, string> = {
  webpage: "Webpage",
  api: "API",
  webhook: "Webhook",
  other: "Other",
  untyped: "Untyped",
};

export const ROUTE_TYPE_ICONS: Record<RouteType, IconName> = {
  webpage: "earth",
  api: "code",
  webhook: "trigger",
  other: "puzzle",
};

export function routeTypeLabel(t: RouteType | null | undefined): string {
  return t ? ROUTE_TYPE_LABELS[t] : "Untyped";
}

export function routeTypeBucketLabel(bucket: RouteTypeBucket): string {
  return ROUTE_TYPE_BUCKET_LABELS[bucket];
}
